var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import di from "../di/serviceLocator";
import summarize from "@domains/utils/summarize";
import { useSelector } from "react-redux";
import loaderGIF from "@frameworks/shared-library/assets/images/Reports/loaderGIF.gif";
var PartnerSummary = function () {
    var _a;
    var _b = __read(React.useState(false), 2), loader = _b[0], setLoader = _b[1];
    var _c = __read(React.useState(""), 2), accountCode = _c[0], setAccountCode = _c[1];
    var _d = __read(useState(false), 2), revenueSummaryLoader = _d[0], setRevenueSummaryLoader = _d[1];
    var _e = __read(React.useState(), 2), partnerClientSummary = _e[0], setPartnerClientSummary = _e[1];
    var _f = __read(useState(null), 2), partnerRevenueSummary = _f[0], setPartnerRevenueSummary = _f[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var selectedPartner = useSelector(function (state) {
        return state.Partners.partnerSummary.reducersData.selectedPartner;
    });
    var revenueSummaryEntity = useSelector(function (state) {
        return state.Partners.partnerSummary.reducersData.partnerRevenueSummaryEntity;
    });
    var partnerClientSummaryEntity = useSelector(function (state) {
        return state.Partners.partnerSummary.reducersData.partnerClientSummaryEntity;
    });
    var getPartnerClientsSummary = function (partnerCode) {
        setLoader(true);
        di.partnerOverview
            .getPartnerClientsSummary({ accountCode: partnerCode })
            .then(function (result) {
            setPartnerClientSummary(result === null || result === void 0 ? void 0 : result.partnerClientsSummary);
            setLoader(false);
            console.log("partnerClientSummary", result);
        })
            .catch(function (error) {
            setLoader(false);
        });
    };
    var getPartnerRevenueSummary = function (partnerCode) {
        setRevenueSummaryLoader(true);
        di.partnerOverview
            .getPartnerRevenueSummary({ accountCode: partnerCode })
            .then(function (result) {
            setPartnerRevenueSummary(result.partnerRevenueSummary);
            setRevenueSummaryLoader(false);
        })
            .catch(function (error) {
            setRevenueSummaryLoader(false);
        });
    };
    useEffect(function () {
        if (selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.accountCode) {
            setAccountCode(selectedPartner === null || selectedPartner === void 0 ? void 0 : selectedPartner.accountCode);
        }
    }, [selectedPartner]);
    useEffect(function () {
        if (accountCode !== "") {
            getPartnerClientsSummary(accountCode);
            getPartnerRevenueSummary(accountCode);
        }
    }, [accountCode]);
    useEffect(function () {
        if (partnerClientSummaryEntity &&
            (partnerClientSummaryEntity === null || partnerClientSummaryEntity === void 0 ? void 0 : partnerClientSummaryEntity.partnerClientsSummary)) {
            setPartnerClientSummary(partnerClientSummaryEntity.partnerClientsSummary);
        }
    }, [partnerClientSummaryEntity]);
    useEffect(function () {
        var _a, _b;
        if (revenueSummaryEntity &&
            (revenueSummaryEntity === null || revenueSummaryEntity === void 0 ? void 0 : revenueSummaryEntity.partnerRevenueSummary) &&
            ((_a = revenueSummaryEntity === null || revenueSummaryEntity === void 0 ? void 0 : revenueSummaryEntity.partnerRevenueSummary) === null || _a === void 0 ? void 0 : _a.curMonth) !== null &&
            ((_b = revenueSummaryEntity === null || revenueSummaryEntity === void 0 ? void 0 : revenueSummaryEntity.partnerRevenueSummary) === null || _b === void 0 ? void 0 : _b.curMonth) > 0) {
            setPartnerRevenueSummary(revenueSummaryEntity.partnerRevenueSummary);
        }
    }, [revenueSummaryEntity]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row d-flex col-gap-10 mx-0 px-0 py-3" },
            React.createElement("div", { className: "col d-flex justify-content-between align-items-center rounded p-3 bg-white g-1" },
                React.createElement("span", { className: "DMSan_14_500 txt_secondary-gray" }, "AUM"),
                React.createElement("b", { className: "RobotoM_16_700 txt_blackOne1" }, loader ? (React.createElement("div", { className: "loader-box px-4" },
                    React.createElement("img", { src: loaderGIF }))) : (summarize(partnerClientSummary === null || partnerClientSummary === void 0 ? void 0 : partnerClientSummary.totalAUM)))),
            React.createElement("div", { className: "col d-flex justify-content-between align-items-center rounded p-3 bg-white g-1" },
                React.createElement("span", { className: "DMSan_14_500 txt_secondary-gray" }, "Number of Clients"),
                React.createElement("b", { className: "RobotoM_16_700 txt_blackOne1" }, loader ? (React.createElement("div", { className: "loader-box px-4" },
                    React.createElement("img", { src: loaderGIF }))) : (partnerClientSummary === null || partnerClientSummary === void 0 ? void 0 : partnerClientSummary.numberOfClients))),
            React.createElement("div", { className: " col d-flex justify-content-between align-items-center  rounded p-3 bg-white g-1" },
                React.createElement("span", { className: "DMSan_14_500 txt_secondary-gray" }, "Revenue (YTD)"),
                React.createElement("b", { className: "RobotoM_16_700 txt_blackOne1" }, revenueSummaryLoader ? (React.createElement("div", { className: "loader-box px-4" },
                    React.createElement("img", { src: loaderGIF }))) : ((_a = partnerRevenueSummary === null || partnerRevenueSummary === void 0 ? void 0 : partnerRevenueSummary.curYear) !== null && _a !== void 0 ? _a : 0))))));
};
export default PartnerSummary;
